<template>
  <v-row>
    <v-col>
      <date-picker
        ref="fromDatePicker"
        label="Desde:"
        :default="defaultFrom"
        :min="min"
        :max="max"
        @selectedDate="SelectedFrom"
      ></date-picker>
    </v-col>
    <v-col>
      <date-picker
        ref="toDatePicker"
        label="Hasta:"
        :default="defaultTo"
        :min="selectedFrom"
        :max="max"
        @selectedDate="SelectedTo"
      ></date-picker>
    </v-col>
    <v-btn
      v-if="isClearable"
      icon
      class="mt-3"
      @click="Reset()"
    >
      <v-icon>{{ mdiClose }}</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'
import DatePicker from '@/components/datepicker/DatePicker.vue'

export default {
  components: {
    DatePicker,
  },
  props: {
    max: { type: String, default: '9999-12-31', required: false },
    min: { type: String, default: '1970-01-01', required: false },
    defaultFrom: { type: String, default: '', required: false },
    defaultTo: { type: String, default: '', required: false },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    clearable: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  setup(props, { emit }) {
    const selectedFrom = ref(props.defaultFrom)
    const selectedTo = ref(props.defaultTo)
    const fromDatePicker = ref()
    const toDatePicker = ref()

    const SelectedFrom = value => {
      selectedFrom.value = value
      emit('selectedFrom', value)
    }

    const SelectedTo = value => {
      selectedTo.value = value
      emit('selectedTo', value)
    }

    const Reset = () => {
      SelectedFrom(props.defaultFrom)
      SelectedTo(props.defaultTo)
      toDatePicker.value.Reset()
      fromDatePicker.value.Reset()
    }

    const isClearable = computed(() => props.clearable && (
      props.defaultFrom !== selectedFrom.value
      || props.defaultTo !== selectedTo.value
    ))

    return {
      selectedFrom,
      fromDatePicker,
      toDatePicker,
      isClearable,
      SelectedFrom,
      SelectedTo,
      Reset,
      mdiClose,
    }
  },
}
</script>
